import { lazyLoad } from 'utils/loadable';

export const EventApplicationFormPage = lazyLoad(
  () => import('./index'),
  module => module.EventApplicationFormPage,
);
